import {useState} from "react";
import {trackProduct, untrackProduct} from "../infrastructure/productApi";
import {isSuccess} from "../../common/domain/RemoteData.model";

export const useTrackingProduct = (product) => {
    const [isTracked, setIsTracked] = useState(product.tracked);

    const handleTrack = async (onSuccessFn, onFailureFn) => {
        try {
            const result = await trackProduct(product.code);
            if (isSuccess(result)) {
                onSuccessFn();
                setIsTracked(true);
            } else {
                onFailureFn();
            }
        } catch (e) {
            onFailureFn();
        }
    }

    const handleUntrack = async (onSuccessFn, onFailureFn) => {
        try {
            const result = await untrackProduct(product.code);
            if (isSuccess(result)) {
                onSuccessFn();
                setIsTracked(false);
            } else {
                onFailureFn();
            }
        } catch (e) {
            onFailureFn();
        }
    }

    return {isTracked, handleTrack, handleUntrack};
};
